import { ShieldX, ArrowLeft, Home } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

interface UnauthorizedProps {
    /** Optional message to show below the heading. */
    message?: string
}

/**
 * Full-page "403 — Unauthorized" component.
 *
 * Displayed by `AuthorizationGate` (via its `fallback` prop) when the
 * current user does not have the required actions for the route.
 */
export function Unauthorized({ message }: UnauthorizedProps) {
    const navigate = useNavigate()

    return (
        <div className="flex flex-col items-center justify-center py-24 px-4 text-center">
            {/* Icon */}
            <div className="flex items-center justify-center h-16 w-16 rounded-full bg-red-50 mb-6">
                <ShieldX className="h-8 w-8 text-red-500" />
            </div>

            {/* Heading */}
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Access Denied
            </h2>

            {/* Description */}
            <p className="text-gray-500 max-w-md mb-8">
                {message ??
                    "You don't have permission to view this page. Contact your administrator if you believe this is an error."}
            </p>

            {/* Actions */}
            <div className="flex items-center gap-3">
                <Button variant="outline" onClick={() => navigate(-1)}>
                    <ArrowLeft className="h-4 w-4 mr-2" />
                    Go Back
                </Button>
                <Button onClick={() => navigate('/')}>
                    <Home className="h-4 w-4 mr-2" />
                    Dashboard
                </Button>
            </div>
        </div>
    )
}
